import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { APP_TYPE } from './app.model';
import { RootState } from '../root/root-types';

export const APP_FEATURE_KEY = 'app';

export const appSlice = createSlice({
  name: APP_FEATURE_KEY,
  initialState: APP_TYPE.ZONO_MONEY,
  reducers: {
    updateAppType(state, action: PayloadAction<APP_TYPE>) {
      return action.payload;
    },
  },
});

export const { updateAppType } = appSlice.actions;

export const getAppState = (rootState: RootState) => rootState[APP_FEATURE_KEY];

export const getAppType = getAppState;

export const getIsFieldOps = createSelector(
  getAppType,
  (appType) => appType === APP_TYPE.FIELDS_OPS
);

export const getIsSellerHub = createSelector(
  getAppType,
  (appType) => appType === APP_TYPE.SELLER_HUB
);
